module.exports = __webpack_public_path__ + "img/ChristineMorrison.f351c82b.jpg";